<template>
  <div style="height:500px;">
    <!-- <div>{{ recordType }}</div> -->
    <vxe-table
      ref="xTable"
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      sort-config.remote
      :sort-config="{ remote: true }"
      export-config
      @sort-change="sortList"
    >
      <!-- 承运主体 -->
      <vxe-table-column>
        <vxe-table-column
          field="networkShipper"
          title="承运主体"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.serialNum"
            placeholder="请输入承运主体"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 运单号 -->
      <vxe-table-column>
        <vxe-table-column
          field="waybillNo"
          title="运单号"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.serialNum"
            placeholder="请输入运单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 流水批次号 -->
      <vxe-table-column>
        <vxe-table-column
          field="batchNo"
          title="流水批次号"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.serialNum"
            placeholder="请输入流水批次号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 客户名称 -->
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="客户名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入客户名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 变动金额 -->
      <vxe-table-column>
        <vxe-table-column
          field="paidAmount"
          title="变动金额"
          min-width="100"
          sortable
        >
          <template slot-scope="{ row }">
            <!-- {{ row.changeAmount }} -->
            <span :class="row.paidAmount > 0 ? 'positive' : 'negative'">
              {{ formatAmount(row.paidAmount) }}
            </span>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <!-- <el-input v-model="listQuery.paidAmount" placeholder="请输入内容" clearable /> -->
          <div class="for-input-range">
            <el-input
              v-model="listQuery.paidAmountMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('paidAmountMin')"
            />
            <el-input
              v-model="listQuery.paidAmountMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('paidAmountMax')"
            />
          </div>
        </template>
      </vxe-table-column>
      <!-- 变动类型 -->
      <vxe-table-column>
        <vxe-table-column
          field="paidLineName"
          title="变动类型"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paidLineType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(v, k) in paidLineTypeMap"
              :key="k"
              :label="v"
              :value="k"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 变动原因 -->
      <vxe-table-column>
        <vxe-table-column
          field="paidItemName"
          title="变动原因"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paidItem"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(v, k) in paidItemMap"
              :key="k"
              :label="v"
              :value="k"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 账户金额 -->
      <vxe-table-column>
        <vxe-table-column
          field="accountAmountBehind"
          title="账户余额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.paidAccountAmountMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('paidAccountAmountMin')"
            />
            <el-input
              v-model="listQuery.paidAccountAmountMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('paidAccountAmountMax')"
            />
          </div>
        </template>
      </vxe-table-column>
      <!-- 操作人 -->
      <vxe-table-column>
        <vxe-table-column
          field="operator"
          title="操作人"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.serialNum"
            placeholder="请输入操作人"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 备注 -->
      <vxe-table-column>
        <vxe-table-column
          field="remark"
          title="备注"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.serialNum"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 变动时间 -->
      <vxe-table-column>
        <vxe-table-column
          field="changeTime"
          title="变动时间"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.serialNum"
            placeholder="请输入变动时间"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 操作 -->
      <vxe-table-column>
        <vxe-table-column
          field="operation"
          title="操作"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.serialNum"
            placeholder="请输入操作"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
export default {
  props: {
    recordType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      paidItemMap: {
        0: "线下充值",
        1: "发货保证金",
        2: "运费",
        3: "保费",
        4: "罚款",
        5: "提现",
        6: "信息费",
        7: "车队分账",
        8: "退款",
        9: "凭证支付",
        10: "凭证提现",
        11: "线上充值",
        12: "网商保证金"
      },
      paidLineTypeMap: { 0: "在线支付", 1: "转账支付" },
      loading: false,
      listQuery: {
        serialNum: ""
      },
      tableData: [
        {
          id: 1,
          networkShipper: "网络货运公司A",
          waybillNo: "WB20230001",
          batchNo: "B20230001",
          customerName: "客户公司一",
          changeAmount: "+5000.00",
          changeType: "充值",
          changeReason: "账户充值",
          accountAmount: "10000.00",
          operator: "张三",
          remark: "正常充值",
          changeTime: "2023-01-01 10:00:00",
          operation: "查看详情",
          paidAmount: 12
        },
        {
          id: 2,
          networkShipper: "网络货运公司B",
          waybillNo: "WB20230002",
          batchNo: "B20230002",
          customerName: "客户公司二",
          changeAmount: "-2000.00",
          changeType: "支付",
          changeReason: "运费支付",
          accountAmount: "8000.00",
          operator: "李四",
          remark: "运单支付",
          changeTime: "2023-01-02 11:30:00",
          operation: "查看详情",
          paidAmount: 12
        },
        {
          id: 3,
          networkShipper: "网络货运公司C",
          waybillNo: "WB20230003",
          batchNo: "B20230003",
          customerName: "客户公司三",
          changeAmount: "+3000.00",
          changeType: "退款",
          changeReason: "订单取消退款",
          accountAmount: "7000.00",
          operator: "王五",
          remark: "客户申请退款",
          changeTime: "2023-01-03 14:20:00",
          operation: "查看详情",
          paidAmount: 12
        },
        {
          id: 4,
          networkShipper: "网络货运公司D",
          waybillNo: "WB20230004",
          batchNo: "B20230004",
          customerName: "客户公司四",
          changeAmount: "-1500.00",
          changeType: "扣款",
          changeReason: "服务费",
          accountAmount: "5500.00",
          operator: "赵六",
          remark: "月度服务费",
          changeTime: "2023-01-04 16:45:00",
          operation: "查看详情",
          paidAmount: 12
        },
        {
          id: 5,
          networkShipper: "网络货运公司E",
          waybillNo: "WB20230005",
          batchNo: "B20230005",
          customerName: "客户公司五",
          changeAmount: "+8000.00",
          changeType: "充值",
          changeReason: "账户充值",
          accountAmount: "15000.00",
          operator: "孙七",
          remark: "大额充值",
          changeTime: "2023-01-05 09:15:00",
          operation: "查看详情",
          paidAmount: 12
        }
      ]
    };
  },
  methods: {
    isNumber4listQuery(key) {
      let val = this.listQuery[key];
      if (val !== "") {
        if (!isNumber(val)) {
          this.$message({ message: "请输入数字！", type: "error" });
        }
        val = parseFloat(val);
        if (isNaN(val)) {
          val = "";
        }
        this.$set(this.listQuery, key, val);
      }
    },
    formatAmount(amount) {
      const sign = amount > 0 ? "+" : "";
      return (
        sign +
        amount.toLocaleString("zh-CN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      );
    },
    sortList(params) {
      console.log("排序参数:", params);
      // 这里可以实现排序逻辑
    }
  }
};
</script>
<style lang="scss" scoped>
.positive {
  color: #00b578;
  font-weight: bold;
}

.negative {
  color: #f53f3f;
  font-weight: bold;
}
</style>
